// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M17 4H0V20H17V15.7232L24 19.7232V4.23382L17 8.43382V4ZM9.5 8H11.5V10H7.5V11L9.5 11C10.6046 11 11.5 11.8954 11.5 13V14C11.5 15.1046 10.6046 16 9.5 16L9.5 17L7.5 17L7.5 16L5.5 16V14H9.5V13H7.5C6.39543 13 5.5 12.1046 5.5 11V10C5.5 8.89543 6.39543 8 7.5 8V7H9.5V8Z"}}]};

const VideoCameraDollarFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'video-camera-dollar-filled',
    ref,
    icon: element,
  },
));

VideoCameraDollarFilledIcon.displayName = 'VideoCameraDollarFilledIcon';

export default VideoCameraDollarFilledIcon;
